import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.keys.js";
import axios from 'axios';
import isJSON from 'validator/lib/isJSON';
import { getDataSet, mergeSentInterface } from '~/core/functions/fingerprints';
import getCSRFToken from '~/core/functions/getCSRFToken';
import { FINGERPRINT_URL } from '~/core/constants';
var sendUserInfo = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _useNuxtApp, $captureException, userInfo, mergedUserInfo;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _useNuxtApp = useNuxtApp(), $captureException = _useNuxtApp.$captureException;
          _context.prev = 1;
          _context.next = 4;
          return getDataSet();
        case 4:
          userInfo = _context.sent;
          mergedUserInfo = mergeSentInterface({
            resultData: isJSON(userInfo) ? JSON.parse(userInfo) : {}
          });
          userInfo = JSON.stringify(mergedUserInfo);
          _context.next = 9;
          return axios.post('', userInfo, {
            baseURL: FINGERPRINT_URL,
            responseType: 'json',
            headers: {
              'Content-Type': 'application/json; charset=utf-8',
              'X-Requested-With': 'XMLHttpRequest',
              'X-CSRFToken': getCSRFToken()
            }
          });
        case 9:
          _context.next = 14;
          break;
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](1);
          $captureException(_context.t0, {
            method: 'fingerprint_middleware'
          });
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 11]]);
  }));
  return function sendUserInfo() {
    return _ref.apply(this, arguments);
  };
}();
export default defineNuxtRouteMiddleware(function () {
  // Запрос не должен блочить переход между страницами
  sendUserInfo();
});